import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ContentChips/ProductMentionText.tsx
import { ProductMentionChip } from "./ProductMentionChip.mjs";
import { PRODUCT_MENTION_REGEX, resolveProductMention, unresolvedMentionText } from "./productMentions.mjs";
import { jsx } from "react/jsx-runtime";
function ProductMentionText({ content, productMap, storeDomain }) {
  const parts = [];
  let lastIndex = 0;
  for (const match of content.matchAll(PRODUCT_MENTION_REGEX)) {
    const [fullMatch, productKey] = match;
    if (match.index > lastIndex) {
      parts.push(content.substring(lastIndex, match.index));
    }
    const product = resolveProductMention(productMap, productKey);
    parts.push(product ? /* @__PURE__ */ jsx(
      ProductMentionChip,
      {
        product,
        storeDomain
      },
      `mention-${productKey}-${match.index}`
    ) : unresolvedMentionText(productKey));
    lastIndex = match.index + fullMatch.length;
  }
  if (lastIndex < content.length) {
    parts.push(content.substring(lastIndex));
  }
  return parts.length > 0 ? parts : content;
}
ProductMentionText.displayName = "ProductMentionText";
export {
  ProductMentionText
};
//# sourceMappingURL=ProductMentionText.mjs.map